import { useEffect, useState } from "react";
import { api, itDate } from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { Empty, ListCard } from "@/components/Crud";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Download, RefreshCcw } from "lucide-react";

export default function Sync() {
  const [d, setD] = useState(null);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/sync/status").then(({ data }) => setD(data));
  useEffect(() => { load(); }, []);

  const importCustomers = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/sync/customers/import");
      setMsg(`Importati ${data.imported} clienti (${data.created} nuovi)${data.mock ? " — dati MOCK" : ""}.`);
      await load();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="sync-page">
      <PageHeader title="Business Experience" subtitle="Integrazione gestionale contabile">
        <Button className="h-11 rounded-sm" onClick={importCustomers} disabled={busy} data-testid="import-customers-btn">
          <Download className="h-4 w-4 mr-2" /> Importa clienti
        </Button>
        <Button variant="outline" className="h-11 rounded-sm" onClick={load} data-testid="refresh-sync-btn">
          <RefreshCcw className="h-4 w-4" />
        </Button>
      </PageHeader>

      <Card className="p-6 rounded-sm shadow-none mb-6">
        <div className="flex items-center gap-2 flex-wrap">
          <p className="overline">Stato connessione</p>
          <Badge className="rounded-sm" variant={d?.mock ? "secondary" : "default"} data-testid="sync-mode-badge">
            {d?.mock ? "MOCK — in attesa di credenziali" : "Connesso"}
          </Badge>
        </div>
        <p className="font-mono text-sm mt-3 break-all">{d?.api_url || "—"}</p>
        <p className="text-sm text-muted-foreground mt-4 leading-relaxed">
          Anagrafiche clienti/agenti e documenti contabili vengono scambiati con Business Experience. Per attivare
          la connessione reale serve l'URL delle API e la chiave (variabili <span className="font-mono">BE_API_URL</span>,{" "}
          <span className="font-mono">BE_API_KEY</span>, <span className="font-mono">BE_MOCK=false</span>).
        </p>
      </Card>

      <h3 className="font-display text-xl font-bold tracking-tight mb-3">Log sincronizzazioni</h3>
      {msg && <p className="mb-4 text-sm font-medium text-primary" data-testid="sync-message">{msg}</p>}
      <ListCard testid="sync-logs">
        {(d?.logs || []).map((l) => (
          <div key={l.id} className="px-6 py-4 flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="font-semibold text-sm capitalize">{l.entity} · {l.direction}</p>
              <p className="text-xs text-muted-foreground">{l.message}</p>
            </div>
            <div className="text-right shrink-0">
              <Badge variant="secondary" className="rounded-sm">{l.count} record</Badge>
              <p className="text-xs text-muted-foreground mt-1">{itDate(l.created_at)}</p>
            </div>
          </div>
        ))}
        {(d?.logs || []).length === 0 && <Empty text="Nessuna sincronizzazione eseguita." />}
      </ListCard>
    </div>
  );
}
